import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import DataGridTableSkeleton from "../../../components/skeletons/DataGridTableSkeleton";

const DASHBOARD_SECTIONS = [
  { title: "Inspection Activity" },
  { title: "Maintenance Activity" },
  { title: "Work Orders" },
  { title: "Missing Asset relations" },
] as const;

function DashboardSectionSkeleton({
  title,
}: {
  title: string;
}) {
  return (
    <div className="col-12 col-xl-6 mb-3">
      <div className="custom-card card h-100">
        <div className="card-header">
          <Typography variant="h2">{title}</Typography>
        </div>
        <div className="card-body">
          <div style={{ height: 350, width: "100%" }}>
            <DataGridTableSkeleton
              height={350}
              rowCount={5}
              showPagination={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function CompanyDashboardSkeleton() {
  return (
    <Box>
      <div className="row">
        {DASHBOARD_SECTIONS.map((section) => (
          <DashboardSectionSkeleton
            key={section.title}
            title={section.title}
          />
        ))}
      </div>
    </Box>
  );
}
